function addAllItems(variantIdArray) {
  var newVariantIdArray = variantIdArray.split(',');

  var product_data = newVariantIdArray.map(variantId => {
    return {quantity: 1, id: variantId}
  })
  
  var data = {
    items: product_data
  }
        
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
        body: JSON.stringify(data)
  })
  .then((response) => {
    if (response.ok) {
    location.href='/cart';
    } else {
    return response.json();
    }
  })
    .then((json) => {
    if (!json) {
    console.log("Product added, navigating to cart!");
    } else {
    alert(json.description);
    }
  })
  .catch((e) => {
  console.error('Error:', e);
});
}